<!--
 * @Author:MX
 * @Date: 2020-08-01 11:25:22
 * @Description: 修改密码
-->
<template>
  <div class="modifyPassword">
      <i class="iconfont iconfanhui" @click="reBack"></i>
    <div class="title">{{$lang('修改密码')}}</div>
    <el-form ref="forgetPwdForm" :model="forgetPwdForm" :rules="rules">
      <el-form-item prop="mobile">
        <el-input :placeholder="$lang('请输入手机号')" v-model="forgetPwdForm.mobile" autocomplete="off" maxlength="16">
          <template slot="prepend">
            <el-select v-model="phoneValue" placeholder="请选择" class="phone-value">
              <el-option
                  v-for="item in options"
                  :key="item.value"
                  :value="item.value">
              </el-option>
            </el-select>
          </template>
        </el-input>
          <span class="getPhoneCode" @click="getPhoneCode" v-if="regainGetCode" :title="$lang('获取手机验证码')">{{$lang('获取手机验证码')}}</span>
          <span class="getPhoneCode" v-else>{{ time }}s</span>
      </el-form-item>
      <!--<el-form-item prop="captcha">
    <el-input :placeholder="$lang('请输入图片验证码')" v-model="codeForm.captcha" autocomplete="off" maxlength="11">
         <i slot="prefix" class="iconfont el-input__icon iconyanzhengma1"></i>
         <i slot="suffix">
            <img :src="verificationImg" alt="" @click="resetCode" style="position: relative;bottom: 1px;">
         </i>
     </el-input>
    </el-form-item> -->
      <el-form-item prop="verifyCode">
        <el-input v-model="forgetPwdForm.verifyCode" type="text" :placeholder="$lang('请输入手机验证码')" autocomplete="new-password">
            <i slot="prefix" class="iconfont el-input__icon iconyanzhengma1"></i>
        </el-input>
      </el-form-item>
      <el-form-item prop="pwd">
        <el-input v-model="forgetPwdForm.pwd" :placeholder="$lang('请输入新密码')"  type="password" autocomplete="new-password">
            <i slot="prefix" class="iconfont el-input__icon iconmima1"></i>
        </el-input>
      </el-form-item>
      <el-form-item prop="passwordS">
        <el-input v-model="forgetPwdForm.passwordS" :placeholder="$lang('确认新密码')" autocomplete="new-password"  type="password" >
            <i slot="prefix" class="iconfont el-input__icon iconmima1"></i>
        </el-input>
      </el-form-item>
    </el-form>
    <el-button type="primary" class="login-btn" @click="sureModify">{{$lang('确定')}}</el-button>
  </div>
</template>

<script type="text/javascript">
import { RULES, phoneMobileModify } from '@utils/rules'
import * as Api from '@api/base/public'
import { RESPONSE_SUCCESS } from '@constants'
export default {
  name: 'ModifyPassword',
  data() {
    const validatePass = (rule, value, callback) => {
      if (value !== this.forgetPwdForm.pwd) {
        callback(new Error(this.$lang('两次密码输入不一致!')))
      } else {
        callback()
      }
    }
    return {
      options: [{
        value: '966',
        label: '966'
      }, {
        value: '971',
        label: '971'
      }, {
        value: '965',
        label: '965'
      }, {
        value: '974',
        label: '974'
      }, {
        value: '973',
        label: '973'
      }, {
        value: '968',
        label: '968'
      }, {
        value: '962',
        label: '962'
      }],
      phoneValue: '966',
      time: 120,
      regainGetCode: true,
      loading: false,
      submitLoading: false,
      forgetPwdForm: {
        mobile: '',
        verifyCode: '',
        pwd: '',
        passwordS: '',
      },
      codeForm: {
        ctoken: '',
        captcha: '',
      },
      rules: {
        mobile: [RULES.required, { validator: phoneMobileModify }],
        verifyCode: [RULES.required],
        pwd: [RULES.required, RULES.checkPassword],
        passwordS: [RULES.required, RULES.checkPassword, { validator: validatePass, trigger: 'blur' }],
      },
      verificationImg: '', // 验证码图片
      captcha: '', // 腾讯验证码
    }
  },
  computed: {
    // 国际化语言
    lang() {
      return this.$store.state.base.lang
    },
  },
  created() {
    // this.getCode()
  },
  mounted() {
    this.initTencentCaptcha()
  },
  methods: {
    // 初始化tx验证码
    initTencentCaptcha() {
      // 生成实例对象
      // eslint-disable-next-line no-undef
      this.captcha = this.$Captcha.init(this.tencentCaptchaCallback, {
        forceLang: this.lang === 'CN' ? 'zh-cn' : 'en',
      })
    },
    // 验证码回调
    async tencentCaptchaCallback(res) {
      console.log('腾讯验证码回调：callback', res)
      // 验证成功，返回对象
      if (res.ret === 0) {
        // 定义参数：票据 随机字符串
        const customParams = {
          ticket: res.ticket,
          randstr: res.randstr
        }
        this.forgetPwdFn(customParams)
      }
      // 验证不成功
      return null
    },
    /**
     * @description 返回
     */
    reBack() {
      this.$emit('reBack')
    },
    toverification() {
      this.$emit('toverification')
    },
    async forgetPwdFn(customParams) {
      const { mobile } = this.forgetPwdForm
      this.loading = true
      const params = {
        phone: mobile,
        countryCode: this.phoneValue,
        ...customParams
        // ctoken: this.codeForm.ctoken,
        // imageVerifyCode: this.codeForm.captcha,
      }
      const { code, msg } = await Api.getCode(params)
      this.loading = false
      if (code === RESPONSE_SUCCESS) {
        this.regainGetCode = false
        clearInterval(this.codeTimer)
        this.codeTimer = setInterval(() => {
          this.time--
          if (this.time === 0) {
            this.time = 120
            this.regainGetCode = true
            clearInterval(this.codeTimer)
          }
        }, 1000)
      } else {
        this.$message.error(msg)
        // this.resetCode()
      }
    },
    /**
     * @description 获取手机短信验证码
     */
    async getPhoneCode() {
      const { mobile } = this.forgetPwdForm
      if (!mobile) { return this.$message.error(this.$lang('请输入手机号')) }
      this.captcha.show()
      // if (!this.codeForm.captcha) {
      //   return this.$message.error(this.$lang('请输入图片验证码'))
      // }
      // const { code, msg } = await Api.getExist({ mobile: (`+${this.phoneValue}-${mobile}`) })
      // console.log('msg11111', code)
      // if (code === RESPONSE_SUCCESS) {
      //   this.captcha.show()
      // } else {
      //   this.$message.error(msg)
      // }
    },
    /**
        * @description 确定
    */
    async sureModify() {
      // this.toverification()
      this.$refs['forgetPwdForm'].validate((valid) => {
        if (valid) {
          this.toverification()
        } else {
          return false
        }
      })
    },
    childMethod(value) {
      // alert(value)
      // alert(555555)
      this.$emit('toverification', 1212)
      this.$parent.verification(12121)
      console.log(value)
      this.submitData(value)
    },
    async submitData(dataVal) {
      this.submitLoading = true
      const { verifyCode, pwd, passwordS, mobile } = this.forgetPwdForm
      const params = {
        countryCode: this.phoneValue, // 区号
        imageVerifyCode: dataVal.captcha, // 图形验证码
        smsCode: verifyCode, // 短信验证码
        password: this.$md5(pwd + 'jadada236t2').toUpperCase(),
        mobile, // 手机号
        confirmPassword: this.$md5(passwordS + 'jadada236t2').toUpperCase(),
        ctoken: dataVal.ctokenTo,
      }
      const { code, msg } = await Api.updatePwdByMobile(params)
      this.submitLoading = false
      if (code === RESPONSE_SUCCESS) {
        this.$message.success(this.$lang('密码修改成功'))
        // this.verificationVisible = false
        this.$emit('reBack')
      } else {
        this.$message.error(msg)
        this.resetCode()
      }
    },
    /**
   * 获取图片验证码
   */
    async getCode() {
      await Api.getCaptcha().then(res => {
        this.verificationImg = res.data.img
        this.codeForm.ctoken = res.data.ctoken
      })
    },
    /**
   * 重新获取图片验证码
   */
    resetCode() {
      // this.getCode()
    },
  },
  beforeDestroy() {
    clearInterval(this.codeTimer)
  },
}
</script>
<style lang="scss">
.modifyPassword{
  .el-input-group__append, .el-input-group__prepend {
    background: transparent;
    border-color:  transparent !important;
    border-bottom: 1px solid #fff !important;
  }
  .phone-value {
    .el-input.el-input--small.el-input--suffix {
      width: 66px !important;
    }
  }
}

</style>
<style lang="scss" scoped>
.modifyPassword{
     .title{
        font-size: 20px;
        font-weight: 500;
        line-height: 30px;
        text-align: center;
        letter-spacing: 6px;
        height: 70px;
    }
    .login-btn{
         width: 100%;
        padding: 0;
        height: 40px;
        line-height: 40px;
        border: none;
        border-radius: 4px;
        background:linear-gradient(90deg,rgba(230,0,18,1) 0%,rgba(230,0,18,1) 100%);
        font-size: 16px;

    }
    .getPhoneCode{
            position: absolute;
            cursor: pointer;
            right: 0;
            padding: 0 15px;
            bottom: 0;
            color: #e60012;

            white-space: nowrap;
            width: 100px;
            overflow: hidden;
            text-overflow: ellipsis;
    }
    .iconfont.iconfanhui {
        position: absolute;
        left: 40px;
        font-size: 25px;
        cursor: pointer;
        color: #e60012;
    }
}
</style>
